import {AuthService, NavigationService, StorageService} from "../services";
import {jwtDecode} from "jwt-decode";
import {SIGN_IN_PAGE_URI} from "../constants/uri.constant";

export default class TokenUtils {
    static saveTokens(accessToken: string, refreshToken: string){
        StorageService.accessToken = accessToken
        StorageService.refreshToken = refreshToken
    }
    static saveCorIdTokens(accessToken: string, refreshToken: string){
        StorageService.accessCorIdToken = accessToken
        StorageService.refreshCorIdToken = refreshToken
    }

    static async getAccessToken() {
        const token: string = StorageService.accessToken || "";

        if(!token){
            return null
        }

        const isUnexpired = this.tokenUnexpired(token)

        if (isUnexpired) {
            return token
        }

        return await this.getRefreshToken()
    }
    static async getRefreshToken() {
        const token: string = StorageService.refreshToken as string;
        const isUnexpired = this.tokenUnexpired(token)

        if (isUnexpired) {
            try {
                const {access_token, refresh_token} = await AuthService.refreshToken()

                if (access_token && refresh_token) {
                    TokenUtils.saveTokens(access_token as string, refresh_token as string)
                    return access_token
                }
            }
            catch (error){
                console.error(error, 'erro with refresh token')
            }
        }

        return null
    }

    static async getAccessCorIdToken() {
        const token: string = StorageService.accessCorIdToken || "";

        if(!token){
            return null
        }

        const isUnexpired = this.tokenUnexpired(token)

        if (isUnexpired) {
            return token
        }

        return await this.getRefreshCorIdToken()
    }
    static async getRefreshCorIdToken() {
        const token: string = StorageService.refreshCorIdToken as string;
        const isUnexpired = this.tokenUnexpired(token)

        if (isUnexpired) {
            try {
                const {access_token, refresh_token} = await AuthService.refreshCorIdToken()

                if (access_token && refresh_token) {
                    TokenUtils.saveCorIdTokens(access_token as string, refresh_token as string)
                    return access_token
                }
            }
            catch (error){
                console.error(error, 'erro with refresh token')
            }
        }

        return null
    }

    static tokenUnexpired(token: string) {
        try {
            const {exp} = jwtDecode(token)

            if (!exp || !token) {
                return false
            }

            // @ts-ignore
            const expTime = exp * 1000;
            const dateNow = new Date().getTime() + 5000;

            return dateNow < expTime;
        } catch (e) {
            return false
        }
    }

    static logout() {
        StorageService.removeTokens()

        NavigationService.navigateTo(SIGN_IN_PAGE_URI);
    }
}

